export { default } from './ExpansionPanelSummary';


//////////////////
// WEBPACK FOOTER
// /home/ig_comp_doc/sandbox-manager-v3/node_modules/@material-ui/core/esm/ExpansionPanelSummary/index.js
// module id = 471
// module chunks = 0